import { FC } from 'react'
import styled from 'styled-components'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { RefsContainer } from '../../../../../../brunswick/containers/refs'
import { CtaButton } from '../../../../../../components/atoms/CtaButton'
import { trackEvent } from '../../../../../../lib/analytics'
import { useRiseAiScript } from '../../../../../../lib/hooks/useRiseAiScript'
import { AddToBagContainer } from '../../contexts/AddToBagContainer'
import { ProductDetailsContainer } from '../../contexts/ProductDetailsContainer'
import { useIsPhysicalGiftCard } from '../../hooks/useIsGiftCard'
import { AddToBagButton } from '../AddToBagButton'
import { GiftAddToBagButtonContainer, RiseButtonContainer } from '../styles'

// Rise AI script is adding 15px bottom padding.... so adding it here to prevent CLS
const StyledAddToBagButton = styled(AddToBagButton)<{ $includeBottomMargin: boolean }>`
  ${o => (o.$includeBottomMargin ? 'margin-bottom: 15px;' : null)};
`

export const GiftCardCtas: FC = () => {
  const { productGroup, selectedVariant, isProductOnWaitlist } =
    ProductDetailsContainer.useContainer()

  const { detailsSectionAddToBagSectionRef } = RefsContainer.useContainer()
  const { giftCard } = useTranslation()

  const { handle: productGroupHandle } = productGroup

  const { onAddToBagClick, isAddToBagDisabled, isAddToCartInFlight } =
    AddToBagContainer.useContainer()

  const isPhysicalGiftCard = useIsPhysicalGiftCard({
    productGroupHandle,
  })
  const giftMyselfText = isPhysicalGiftCard ? giftCard.giftMyself : giftCard.emailMyself
  const giftSomeoneElseText = isPhysicalGiftCard
    ? giftCard.giftSomeoneElse
    : giftCard.emailSomeoneElse

  const shopifyId: string = selectedVariant?.product?.shopifyId ?? ''

  useRiseAiScript({
    giftCardShopifyId: shopifyId,
  })

  return (
    <>
      <GiftAddToBagButtonContainer
        forceZeroMarginRight={true}
        ref={detailsSectionAddToBagSectionRef}
      >
        <StyledAddToBagButton
          onClickAddToBag={onAddToBagClick}
          cta={giftMyselfText}
          className='Rise-add-to-cart-button'
          isProcessing={isAddToCartInFlight}
          isDisabled={isAddToBagDisabled}
          isWaitlist={isProductOnWaitlist}
          $includeBottomMargin={!isPhysicalGiftCard}
        />
      </GiftAddToBagButtonContainer>

      {!isPhysicalGiftCard ? (
        <RiseButtonContainer>
          <CtaButton
            {...trackEvent({
              action: 'rise add to cart',
              category: 'product details',
              label: giftSomeoneElseText,
            })}
            allCaps={true}
            aria-disabled={false}
            block
            className='gwbutton'
            data-testid='rise-add-to-bag-button'
            variant='filled'
          >
            {giftSomeoneElseText}
          </CtaButton>
        </RiseButtonContainer>
      ) : null}
    </>
  )
}
